import { createReducer, on } from '@ngrx/store';

import { gotoDetails } from '../actions/create-course.actions';

export const createCourseKey = 'createCourse';

export interface CreateCourseState {
  gotoDetails: boolean;
}

export const initialState: CreateCourseState = {
  gotoDetails: true
};

const reducer = createReducer(
  initialState,
  on(gotoDetails, (state) => ({ ...state, gotoDetails: !state.gotoDetails }))
);

export function createCourseReducer(state, action): CreateCourseState {
  return reducer(state, action);
}
